import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../environments/environment';
import { BaseRichService } from '../../../providers/base-rich.service';
import { ListComponent } from '../../shared/list/list.component';
import { ChangeInvoiceComponent } from '../../sales/change-invoice/change-invoice.component';

@Component({
  selector: 'app-invoice-draft-list',
  templateUrl: '../../shared/base-list/base-list.component.html',
  styleUrls: ['./invoice-draft-list.component.scss', '../../shared/base-list/base-list.component.scss']
})
export class InvoiceDraftListComponent extends ListComponent implements OnInit {

  constructor(
    public cookieService: CookieService,
    public activeModal: NgbModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: BaseRichService,
    public route: ActivatedRoute,
    public router: Router
  ) {
    super(cookieService, activeModal, titleService, translator, service, route, router);
    this.entity = 'invoice';
    this.subentity = 'draft';
  }

  async perform(action, row) {
    return new Promise(async (resolve, reject) => {
      try {
        switch (action.name) {
          case 'PAY':
            this.loadingVisible = true;
            this.service.perform(this.entity, action.name, row).subscribe((result: any) => {
              this.loadingVisible = false;
              if (result.credit) {
                this.handleSuccess();
              } else if (result.gate) {
                if (result.gate == 'ASP') {
                  const params = new URL(result.redirectUrl).searchParams;
                  const RefId = params.get('RefId');
                  const mobileap = params.get('mobileap');
                  this.postRefId(RefId, mobileap)
                } else {

                  if (result.redirectUrl) {
                    window.location.href = result.redirectUrl;
                  } else {
                    this.handleError({ message: this.translator.instant('GATE_EMPTY_REDIRECT') });
                  }
                }
              } else {
                this.handleError({ message: this.translator.instant('GATE_EMPTY') });
              }
            }, error => {
              this.loadingVisible = false;
              this.handleError(error);
            });
            break;
          case 'PRINT':
            this.service.perform(this.entity, action.name, row, { responseType: 'blob' }).subscribe(async (blob: Blob) => {
              const url = window.URL.createObjectURL(blob);
              const a =
                document.createElement('a');
              a.href = url;
              a.download = `${this.translator.instant('INVOICE')}-${row.id}.pdf`;
              a.click();
              window.URL.revokeObjectURL(url);
              resolve(true);
            }, error => {
              this.handleError(error);
            });
            // window.open(`${environment.jasper}flow.html?_flowId=viewReportFlow&_flowId=viewReportFlow&ParentFolderUri=%2Freports&reportUnit=%2Freports%2FPreInvoiceReport${this.lang === 'en' ? '_en' : ''}&standAlone=true&j_username=jasper&j_password=ja5p3r&output=pdf&InvoiceId=${row.id}`, '_blank');
            break;
          default:
            await super.perform(action, row);
            resolve(true);
        }
      } catch (error) {
        reject(error);
      }
    });
  }

  getBody(): any {
    const body = super.getBody();
    let query = ['status', '=', 'D'] as any;
    if (this.selectedAccount) {
      body.mode = 'user';
      query = [
        ['account_id', '=', this.selectedAccount],
        'and',
        query
      ];
    }
    if (body.query) {
      body.query = [body.query, 'and', query];
    } else {
      body.query = query;
    }
    return body;
  }

  async prepare(action, rows) {
    if (action.name.toLowerCase() === 'change_invoice') {
      for (const row of rows) {
        const wirelessList = this.activeModal.open(ChangeInvoiceComponent, { size: 'sm' });
        wirelessList.componentInstance.invoice = row;
      }
    } else {
      await super.prepare(action, rows);
    }
  }

  postRefId(refIdValue, mobileap) {
    var form = document.createElement("form");
    form.setAttribute("method", "POST");
    form.setAttribute("action", "https://asan.shaparak.ir");
    form.setAttribute("target", "_self");

    var refIdField = document.createElement("input");
    refIdField.setAttribute("name", "RefId");
    refIdField.setAttribute("value", refIdValue);
    form.appendChild(refIdField);

    var mobileField = document.createElement("input");
    mobileField.setAttribute("name", "mobileap");
    mobileField.setAttribute("value", mobileap);
    form.appendChild(mobileField);

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }
}
